import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.timesheet || initialState;

export const selectTimesheet = createSelector([selectSlice], state => state);
